import styled from "@emotion/styled"
import Beautyshot from "components/beautyshot/Beautyshot"
import { useEnv } from "contexts/Env"
import { motion } from "framer-motion"
import { useRef } from "react"
import imageLoader, { imageLoaderOneSrc } from "./imageLoader"
export const WIDTHS = [240, 320, 640, 800, 1200, 1600, 1920, 2440, 3200, 3840]

// export const ImgPlaceholder = css`
//   background-color: rgb(127 127 127 / 0.1);
//   background-image: url("data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNSAxNSIgdmlld0JveD0iMCAwIDE1IDE1IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0yLjEgNS4zaC4ybDIuMyA3LjdjLjMuOSAxLjUgMS41IDMgMS41czIuOC0uNyAzLTEuNWwyLjMtNy43aC4yYy40IDAgLjgtLjQuOC0uOHMtLjQtLjgtLjgtLjgtLjguNC0uOC44YzAgLjMuMi42LjUuN2wtMi42IDUuNy40LTcuNmMuNCAwIC44LS40LjgtLjhzLS40LS44LS44LS44LS44LjQtLjguOC4yLjcuNi44bC0xLjggNy40LS45LTguM2MuNCAwIC43LS40LjctLjhzLS40LS44LS44LS44LS44LjQtLjguOC4zLjcuNy44bC0uOCA4LjItMS44LTcuNGMuMy0uMS42LS40LjYtLjhzLS40LS44LS44LS44Yy0uNSAwLS44LjQtLjguOHMuNC44LjguOGwuNCA3LjYtMi42LTUuNmMuMi0uMi40LS40LjQtLjcgMC0uNC0uNC0uOC0uOC0uOHMtLjguMy0uOC44YzAgLjQuNC44LjguOHptNS41IDdjMS40IDAgMi41LjQgMi41LjhzLTEuMS44LTIuNS44LTIuNS0uNC0yLjUtLjggMS4xLS44IDIuNS0uOHoiIGZpbGw9InJnYigxMjcgMTI3IDEyNyAvIDAuMikiLz48L3N2Zz4=");
//   background-position: 50% 50%;
//   background-repeat: no-repeat;
//   background-size: 30px;
// `

const Img = styled(motion.img)`
  color: rgb(0 0 0 / 0); // alt
  height: auto;
  max-width: 100%;

  &.img-is-logo {
    object-fit: contain;
    max-height: 120px;
    max-width: fit-content;
    figure & {
      display: flex;
      margin: auto;
    }
  }
`

const reverseMedia = {
  portrait: "(max-width: 767px)",
  landscape: "(min-width: 768px)",
}

export default function ImageCLD(props) {
  const {
    className,
    alt = "",
    sources: sourcesNonLocalizable,
    sources_localized: sourcesLocalized,
    loading,
    decoding = loading === "lazy" ? "async" : null,
    quality = "auto:eco",
    widths = WIDTHS,
    sizes = "auto (min-width: 48rem) 33.3vw, 84vw",
    sourceMedia = reverseMedia,
    animate,
    initial,
    transition,
    beautyshot,
    fig_caption,
    theme,
    blur,
    style,
    is_logo,
    fetchpriority = "auto",
  } = props
  const env = useEnv()
  const rpicture = useRef(null)
  const rimg = useRef(null)

  function clickPopinButton() {
    const pictureButton = rpicture?.current?.querySelector("button")
    const imgButton = rimg?.current?.querySelector("button")
    if (pictureButton) pictureButton.click()
    if (imgButton) imgButton.click()
  }
  const sources = sourcesLocalized?.length ? sourcesLocalized : sourcesNonLocalizable
  const isLogo = is_logo === true
  const autoSizes = sizes?.startsWith?.("auto") ? sizes : `auto ${sizes}`

  return sources?.length > 1 ? (
    <picture ref={rpicture} onClick={clickPopinButton} className={className}>
      {beautyshot?.rmc && <Beautyshot parentTheme={theme} notFullscreen beautyshot={beautyshot} fig_caption={fig_caption} />}

      {sources?.map((source, i) => {
        const { metadata, width, height, policy, path } = source
        const device = metadata?.v7_type && metadata?.v7_type[0] === "portrait" ? "portrait" : "landscape"

        // Initialize imageLoader ONCE per source instead of once per width
        const getUrl = imageLoader({ src: source, policy, path }, env)

        return (
          <source
            key={`source-${i}`}
            media={sourceMedia[device]}
            srcSet={widths
              ?.map(c => {
                const imageUrl = getUrl({ width: c, quality: quality ?? "auto:eco", blur })
                return imageUrl ? `${imageUrl} ${c}w` : null
              })
              .filter(Boolean)
              .join(", ")}
            sizes={sizes}
            width={width}
            height={height}
          />
        )
      })}
      <Img
        src={imageLoader({ src: sources[0], policy: sources[0].policy, path: sources[0].path }, env)({ width: "1920", quality: quality ?? "auto:eco", blur })}
        initial={initial}
        animate={animate}
        transition={transition}
        alt={alt}
        className={`${isLogo ? "img-is-logo" : ""} ${className}`}
        loading={loading}
        decoding={decoding}
        style={Object.assign(style ?? {})}
        fetchpriority={fetchpriority}
      />
    </picture>
  ) : (
    sources?.map((source, i) => {
      const { width, height, policy, path } = source

      // Initialize imageLoader ONCE per source instead of once per width
      const getUrl = imageLoader({ src: source, policy, path }, env)

      return (
        <Img
          src={getUrl({ width: "1920", quality: quality ?? "auto:eco", blur })}
          key={`image-${i}`}
          alt={alt}
          className={`${isLogo ? "img-is-logo" : ""} ${className}`}
          loading={loading}
          srcSet={widths
            ?.map(c => {
              const imageUrl = getUrl({ width: c, quality: quality ?? "auto:eco", blur })
              return imageUrl ? `${imageUrl} ${c}w` : null
            })
            .filter(Boolean)
            .join(", ")}
          width={width}
          height={height}
          sizes={sizes}
          decoding={decoding}
          fetchpriority={fetchpriority}
        />
      )
    })
  )
}

export function ImageCLDOneSrc(props) {
  const {
    className,
    alt = "",
    sources: sourcesNonLocalizable,
    sources_localized: sourcesLocalized,
    loading,
    decoding = loading === "lazy" ? "async" : null,
    quality,
    // widths = WIDTHS,
    sizes = "auto (min-width: 48rem) 33.3vw, 84vw",
    sourceMedia = reverseMedia,
    beautyshot,
    fig_caption,
    theme,
    is_logo,
    fetchpriority = "auto",
  } = props
  const env = useEnv()

  const rpicture = useRef(null)
  const rimg = useRef(null)
  function clickPopinButton() {
    if (rpicture) rpicture?.current.querySelector("button").click()
    else rimg?.current.querySelector("button").click()
  }
  const sources = sourcesLocalized?.length ? sourcesLocalized : sourcesNonLocalizable
  const isLogo = is_logo === true

  return sources?.length > 1 ? (
    <picture onClick={clickPopinButton} ref={rpicture}>
      {beautyshot && <Beautyshot theme={theme} notFullscreen beautyshot={beautyshot} fig_caption={fig_caption} />}
      {sources?.map((source, i) => {
        const { metadata, width, height, policy, path } = source
        const device = metadata?.v7_type && metadata?.v7_type[0] === "portrait" ? "portrait" : "landscape"
        const autoSizes = sizes?.startsWith?.("auto") ? sizes : `auto ${sizes}`
        return (
          <source
            key={`source-${i}`}
            media={sourceMedia[device]}
            srcSet={imageLoaderOneSrc({ src: source, policy, path }, env)({ quality: quality ?? "auto:best" })}
            sizes={autoSizes}
            width={width}
            height={height}
          />
        )
      })}
      <Img
        src={`${imageLoader(
          { src: sources[0], policy: sources[0].policy, path: sources[0].path },
          env
        )({ width: "1920", quality: quality ?? "auto:eco" })}.jpg`}
        alt={alt}
        className={`${isLogo ? "img-is-logo" : ""} ${className}`}
        loading={loading}
        decoding={decoding}
        fetchpriority={fetchpriority}
      />
    </picture>
  ) : (
    sources?.map((source, i) => {
      const { width, height, policy, path } = source
      const autoSizes = sizes?.startsWith?.("auto") ? sizes : `auto ${sizes}`
      return (
        <Img
          src={imageLoader({ src: source, policy, path }, env)({ width: "1920", quality: quality ?? "auto:eco" })}
          key={`image-${i}`}
          alt={alt}
          className={`${isLogo ? "img-is-logo" : ""} ${className}`}
          loading={loading}
          srcSet={imageLoaderOneSrc({ src: source, policy, path }, env)({ quality: quality ?? "auto:best" })}
          width={width}
          height={height}
          sizes={autoSizes}
          decoding={decoding}
          fetchpriority={fetchpriority}
        />
      )
    })
  )
}
